const Container = ({ children }) => (
  <div className="container bg-white mx-auto p-10 mb-6" style={{maxWidth: '400px'}}>{children}</div>
);

export default Container;
